export const colorZonaByTipo = (status) => {
    /*
        1.- Solicitud asignada al inspector
        1.- si no ha pasado el inspector: pendiente inspeccion.
        2.- si ya paso el inspector: informe emitido.
        3.- si esta en proceso de revision del informe: informe en revisión.
        4.- Si ya lo reviso el gerente: dictamen emitido.
        5.- Cuando se finalize todo el proceso: Solictud atendida
    */
    switch (status) {
        case 0:
            return 'alert-success'
            break;
        case 1:
            return 'alert-primary'
            break;

        default: 'alert-info'
            break;
    }

}